import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { CATALOGO_PADRAO } from './helpers';

const messages = defineMessages({
  titleBlock: {
    id: 'mpf_servicos_catalogo_block',
    defaultMessage: 'Todos os serviços',
  },
  titulo: { id: 'mpf_servicos_catalogo_titulo', defaultMessage: 'Título' },
  pasta: {
    id: 'mpf_servicos_catalogo_pasta',
    defaultMessage: 'Pasta de serviços',
  },
  pastaHelp: {
    id: 'mpf_servicos_catalogo_pasta_help',
    defaultMessage:
      'Cada Categoria de Serviço da pasta vira um card, na ordem da pasta. Para mudar a ordem ou o ícone, edite a pasta e as categorias.',
  },
  exibirLegenda: {
    id: 'mpf_servicos_catalogo_exibir_legenda',
    defaultMessage: 'Exibir a legenda dos selos gov.br',
  },
  legenda: {
    id: 'mpf_servicos_catalogo_legenda',
    defaultMessage: 'Texto da legenda',
  },
});

export const mpfServicosCatalogoSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.titleBlock),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['titulo', 'pasta', 'exibirLegenda', 'legenda'],
    },
  ],
  properties: {
    titulo: {
      title: intl.formatMessage(messages.titulo),
      default: CATALOGO_PADRAO.titulo,
    },
    pasta: {
      title: intl.formatMessage(messages.pasta),
      description: intl.formatMessage(messages.pastaHelp),
      widget: 'object_browser',
      mode: 'link',
      selectableTypes: ['PastaServicos'],
      allowExternals: false,
    },
    exibirLegenda: {
      title: intl.formatMessage(messages.exibirLegenda),
      type: 'boolean',
      widget: 'toggle',
      default: true,
    },
    legenda: {
      title: intl.formatMessage(messages.legenda),
      widget: 'textarea',
      default: CATALOGO_PADRAO.legenda,
    },
  },
  required: [],
});
